import { MileageUnit } from "@/src/types/types";
import type { CaravanType } from "@/src/utils/caravanTypes";

import { atomWithStorage } from "jotai/utils";

export { MileageUnit } from "@/src/types/types";

// Step 1 / 12
export const auctionStepRegnoMileageStateAtom = atomWithStorage<{
  regno: string;
  mileage: number | null;
  mileageUnit?: MileageUnit;
  caravanType?: CaravanType;
  caravanTypeId?: number;
  kuntoraportti?: {
    available: boolean;
    inspectionId?: string;
    include: boolean;
  };
}>(
  "auctionStepRegnoMileageStateAtom",
  { regno: "", mileage: null, mileageUnit: MileageUnit.KM },
  undefined,
  { getOnInit: true }
);
